import React from 'react';
import PropTypes from 'prop-types';
import {
  Button, Card, CardBody, CardHeader, Col, Row,
} from 'reactstrap';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { fetchWallpapers } from '../../actions/wallpapers';
import DataTable from '../../components/data-table';

const COLUMNS = [
  { id: ['link', 'thumbnail'], label: '', image: true },
  { id: 'wallpaperID', label: 'ID', link: true },
  { id: 'title', label: 'Title', link: true },
  { id: 'link', label: 'Link' },
  { id: 'category', label: 'Category' },
  { id: 'device', label: 'Device' },
  { id: 'type', label: 'Type' },
  { id: 'twoTones', label: '2 Tones', boolean: true },
  { id: 'default', label: 'Default', boolean: true },
  { id: 'order', label: 'Order' },
];

const Wallpapers = (props) => {
  const { getWallpapers } = props;
  return (
    <div className="animated fadeIn">
      <Row>
        <Col xl={12}>
          <Card>
            <CardHeader>
              <Row>
                <Col lg={4}>
                    Wallpapers
                </Col>
                <Col lg={8} style={{ textAlign: 'right' }}>
                  <Button href="/#/wallpapers/new" color="success" size="sm">New</Button>
                </Col>
              </Row>
            </CardHeader>
            <CardBody>
              <DataTable
                resource="wallpapers"
                dataSource={getWallpapers}
                columns={COLUMNS}
                {...props}
              />
            </CardBody>
          </Card>
        </Col>
      </Row>
    </div>
  );
};

Wallpapers.propTypes = {
  getWallpapers: PropTypes.func.isRequired,
  loading: PropTypes.bool.isRequired,
  wallpapers: PropTypes.arrayOf(PropTypes.object),
};

Wallpapers.defaultProps = {
  wallpapers: [],
};

const mapStateToProps = ({ wallpapers }) => ({
  loading: wallpapers.loading,
  wallpapers: wallpapers.items,
});

const mapDispatchToProps = dispatch => bindActionCreators({
  getWallpapers: sort => fetchWallpapers(sort),
}, dispatch);

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(Wallpapers);
